<template>
  <v-container>
    <material-card
      :title="Item.title"
      :text="Item.subTitle"
      color="green"> 
      <v-form
      ref="form"
      v-model="valid"
      lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex v-for="(iField,index) in Field" :key="index" :class="[Item.width]">
              <v-text-field
              :type="iField.type"
                :label="iField.label"
                :name="iField.formName"
                class="green-input"
                :disabled="!iField.isEnable"
                 v-model="modelList[iField.name]"
                 :rules="iField.nameRules"
                 />
                 
                  <!-- <span
                    class="tim-note"
                    v-text="errors.first(iField.formName)"
                  /> -->
            </v-flex>
            <v-flex
              xs12
              text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success" @click="onClickButton">{{ Item.submitText }}</v-btn>
              <v-btn
                class="mx-2 font-weight-light"
                color="info" @click="closeModal">Close</v-btn>
                
            </v-flex> 
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
  </v-container>
</template>

<script>
export default {
  props: {
    // title: String,
    Item: Object,
    Field: Array,
    Value: Object
  },
  watch: {
    dialog() {
        this.$refs.form.reset()
    }
  },
  data () {
      return {
      overlay: false,
      valid: true,
      modelList: {}
      }
  },
  watch: {
      overlay (val) {
        val && setTimeout(() => {
          this.overlay = false
        }, 3000)
      },
  },
  created () {
    console.log(this.Value) 
    this.modelList = this.Value
  },
  methods: {
    onClickButton (event) {
      if (this.$refs.form.validate()) {
        this.overlay = true
        this.$emit('emitted', this.modelList)
      } else {
        console.log('Second')
      }
    },
    closeModal () {
      this.$refs.form.reset()
      this.$emit('closed')
    }
  }
}
</script>
